import React from 'react'
import Box from 'react-bulma-components/lib/components/box'

import L from 'leaflet'
import 'proj4leaflet'
import { Map, ScaleControl } from 'react-leaflet'

import 'leaflet/dist/leaflet.css'
import './BNGMap.sass'

export const epsg = 'EPSG:27700'
export const proj = '+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +ellps=airy +datum=OSGB36 +units=m +no_defs'
const crs27700 = new L.Proj.CRS(
  epsg,
  proj,
  {
    resolutions: [2500, 1792, 896, 448, 224, 112, 56, 28, 14, 7, 3.5, 1.75, 0.875, 0.4375, 0.21875, 0.109375],
    origin: [-238375, 1376256]
  }
)

export default (props) => {
  return <Box className='map'>
    <Map
      attributionControl={false}
      center={[55.3, -3.5]}
      crs={crs27700}
      zoom={0}
    >
      <ScaleControl imperial={false} />
      {props.children}
    </Map>
  </Box>
}
